"use client";

import {
	useEffect,
	useState,
	type ChangeEvent,
	type Dispatch,
	type SetStateAction,
} from "react";
import Image from "next/image";
import "./search-drawer.scss";
import leftSideDottedGrid from "@/public/algolia-search/search-left-side-dotted-grid.svg";
import rightSideDottedGrid from "@/public/algolia-search/search-right-side-dotted-grid.svg";
import { t } from "@/utils";
import { HmcIcon } from "@adi-ctx/harmonic-core-components-react";
import { pathNames } from "@/lib/constants/pathNames.constants";
import FilterKeywordSearch from "../FilterKeywordSearch/FilterKeywordSearch";
import { useRouter } from "next-nprogress-bar";
import { useSearchParams } from "next/navigation";

type TSearchDrawer = {
	readonly setIsOpenCb: Dispatch<SetStateAction<boolean>>;
};

export default function SearchDrawer({ setIsOpenCb }: TSearchDrawer) {
	const router = useRouter();
	const searchParams = useSearchParams();

	const [isDisabled, setIsDisabled] = useState(false);

	const handleOnKeyDown = (
		e: KeyboardEvent & ChangeEvent<HTMLInputElement>
	) => {
		const params = new URLSearchParams();
		params.set("keyword", e.target?.value);

		const updatedPath = `${pathNames.search}?${params.toString()}`;

		if (e.key === "Enter") {
			router.push(updatedPath);
			setIsDisabled(true);
		}
	};

	useEffect(() => {
		if (searchParams.get("keyword")) {
			setIsOpenCb(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [searchParams]);

	return (
		<>
			<div className="absolute z-20 flex h-[366px] w-full bg-layoutContainer ">
				<Image
					src={leftSideDottedGrid}
					alt="hero ground image"
					className="absolute bottom-[14px] left-[14px]"
				/>

				<Image
					src={rightSideDottedGrid}
					alt="hero ground image"
					className="absolute bottom-[14px] right-[14px]"
				/>

				<HmcIcon
					name="close-m"
					class="absolute right-2 top-2 cursor-pointer"
					onClick={() => {
						setIsOpenCb(false);
					}}
				/>

				<div className="w-100 mb-8 flex flex-1 flex-col items-center justify-center">
					<div>
						<h1
							data-testid="search-drawer-left-header"
							className="mb-[40px] text-[28px] font-bold "
						>
							{t("search.placeholder")}
						</h1>

						<FilterKeywordSearch
							isDisabled={isDisabled}
							placeholder={t("search.button-search-title")}
							onKeyDown={handleOnKeyDown}
						/>
					</div>
				</div>
			</div>

			<div
				className="search-drawer absolute z-10 flex h-full w-full"
				data-testid="search-drawer-overlay"
				onClick={() => {
					setIsOpenCb(false);
				}}
			/>
		</>
	);
}
